import React from 'react';
import { Button } from '@mui/material';
import { selectedButtonStyle1, selectedButtonStyle2, buttonStyle1, buttonStyle2 } from '../ReusableStyles/ButtonStyles';

interface StandingButtonProps {
  isSelected: boolean;
  isSelectedFn: boolean;
  onClick: () => void;
}

const StandingButton: React.FC<StandingButtonProps> = ({ isSelected,isSelectedFn, onClick }) => {
  return (
    <div className="standingBtn">
      <div style={isSelectedFn ? selectedButtonStyle1 : selectedButtonStyle2}></div>
      <Button
        variant="contained"
        color="inherit"
        size="small"
        onClick={onClick}
        sx={isSelected ? buttonStyle1 : buttonStyle2}
      >
        Standing
      </Button>
    </div>
  );
};

export default StandingButton;